import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SortConfiguration } from '../components/generics/data-table/data-table.component';
import { Comercial } from '../models/comercial.model';
import { UtilsService } from './utils.service';

@Injectable({
    providedIn: 'root'
})
export class ComercialesService {

    constructor(
        private http: HttpClient,
        private utilsService: UtilsService
    ) { }

    getComerciales(page: number, itemsPerPage: number, sorts: SortConfiguration[], extraParams: any) {
        const url = '/comerciales';
        const headers = {
            'page-number': String(page),
            'page-size': String(itemsPerPage)
        };
        const params = {
            'sort-by': this.utilsService.generateSortQueryParam(sorts)
        };
        Object.assign(params, JSON.parse(JSON.stringify(extraParams)));
        return this.http.get<Comercial[]>(url, { headers, observe: 'response', params });
    }

    getComercialById(id: number) {
        return this.http.get<Comercial>(`/comerciales/${id}`);
    }

    getMiComercial() {
        return this.http.get<Comercial>('/comerciales/mi-comercial', { observe: 'response' });
    }

    createComercial(comercial: Comercial) {
        return this.http.post<Comercial>('/comerciales', comercial);
    }

    updateComercial(comercial: Comercial) {
        return this.http.put<Comercial>(`/comerciales/${comercial.id}`, comercial);
    }

    deleteComercial(id: number) {
        return this.http.delete<Comercial>(`/comerciales/${id}`);
    }
}
